/** Practical email shape check (local-part @ domain with at least one dot). */
export function isValidEmailFormat(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}

export function containsWhitespace(value: string): boolean {
  return /\s/.test(value);
}
